import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HelixPalette, HelixStyles, IExternalLink, Typography } from '@ideagen/helix-react-core';
import './ActionButton.scss';
/**
 * ActionButton component to display an action from the agent as a clickable link
 */
export const ActionButton = ({ dataId, action, label }) => {
    return (_jsxs("a", { className: 'helix-react-ai-action-button', href: action, target: "_blank", rel: "noopener noreferrer", "data-id": `${dataId}-action-button`, "aria-label": label, children: [_jsx(IExternalLink, { size: 20, color: HelixPalette.neutral100 }), _jsx(Typography, Object.assign({}, HelixStyles.style_04, { sx: { color: HelixPalette.neutral100 }, children: label }))] }));
};
export default ActionButton;
